// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".authority .el-input-number {\n  margin-left: 15px;\n}\n.authority .el-input-number span {\n  display: none;\n}\n.authority .button-box {\n  padding: 10px 20px;\n}\n.authority .button-box .el-button {\n  float: right;\n}\n.role-box .el-tabs__content {\n  height: calc(100vh - 150px);\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
